import { Component, Input } from '@angular/core';
import { ApplicationLink } from '@user-interfaces/common';

@Component({
    selector: 'success-overlay',
    template: `
        <div
            name="success"
            class="fixed inset-0 flex flex-col bg-secondary items-center justify-center z-50 text-white"
        >
            <ng-container *ngIf="!loading; else load_state">
                <div
                    class="text-4xl rounded-full bg-white mb-4"
                    [class.text-success]="!error"
                    [class.text-error]="error"
                >
                    <app-icon>{{ error ? 'close' : 'done' }}</app-icon>
                </div>
                <div class="text-center text-lg mb-4">
                    <ng-container *ngIf="!error">
                        <ng-content></ng-content>
                    </ng-container>
                </div>
                <div class="flex items-center space-x-2">
                    <a
                        button
                        mat-button
                        class="w-32"
                        *ngFor="let link of links"
                        [routerLink]="[link.route]"
                    >
                        {{ link.name }}
                    </a>
                </div>
            </ng-container>
        </div>
        <ng-template #load_state>
            <mat-spinner [diameter]="32" class="mb-4"></mat-spinner>
            <p class="text-center text-lg">{{ loading }}</p>
        </ng-template>
    `,
    styles: [``],
})
export class SuccessOverlayComponent {
    /** Whether overlay is loading */
    @Input() public loading: string = '';
    /** Details about any errors that have occurred */
    @Input() public error: string = '';
    /** Links to display on success */
    @Input() public links: ApplicationLink[] = [];
}
